export default __webpack_public_path__ + "static/media/Clock.12806b18.svg";